import 'intersection-observer'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import log from 'blazar-sentry'
import { LoginAlert } from '@blocket/authentication-fe'
import '@blazar-plugins/features'
import '@blazar-plugins/device'
import '@blazar-plugins/ufti'
import { Configurator as PulseConfigurator } from '@blocket/tracking-pulse'
import _ from 'lodash'
import { actionCreators as apiActionCreators } from 'reduxBits/api/actions'
import messageCenterPlugin from '@blazar-plugins/message-center-count'
import adWatchesCountPlugin from '@blazar-plugins/ad-watches-count'
import ErrorComponent from 'components/ErrorComponent'
import RestoreScroll from 'components/RestoreScroll'
import TrackPlacementProvider from 'components/TrackPlacement/TrackPlacementProvider'
import staticFilesUrl from 'utils/staticFilesUrl'
import AdBlockDetector from './AdBlockDetector'
import Configuration from './Configuration'
import Head from './Head'
import Canonical from './Canonical'
import Magic from './Magic'
import Notifications from './Notifications'
import Sentry from './Sentry'
import GlobalData from './GlobalData'
import GoogleTagmanagerConfigurator from './GoogleTagmanagerConfigurator'
import Performance from './Performance'
import AppNexusConfig from './AppNexusConfig'
import Glimr from './Glimr'
import EventPolyfill from '../../polyfills/Event'

messageCenterPlugin.initialize({
  mcUserIdSelector: (state) => {
    return _.get(state, 'account.user.propertyMap.mcUserId')
  },
  apiFetch: apiActionCreators.fetch,
  isLoggedInSelector: (state) => state.authentication.loggedIn,
})

adWatchesCountPlugin.apiFetch = apiActionCreators.fetch
adWatchesCountPlugin.isLoggedInSelector = (state) => state.authentication.loggedIn

class Root extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  componentDidUpdate() {
    // fixes bug on iOS where the page is entirely blank until scrolled
    // Reproduce with the following steps:
    // 1. remove this scrollBy; 2. scroll down on LI; 3. click on an ad;
    // 4. refresh page; 5. Click the back button
    // 6. It doesn't always happen, Repeat from 2
    setTimeout(() => {
      window.scrollBy(0, 0)
    }, 0)
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
    })
    log.error(error, { info })
  }

  render() {
    return (
      <TrackPlacementProvider>
        <Head />
        <EventPolyfill />
        <Canonical />
        <AdBlockDetector />
        <Configuration />
        <PulseConfigurator
          providerId="blocket-temp"
          author=""
          environment="production"
          applicationName="blocket-web-adout"
          applicationVersion="1.0.0"
        />
        <Magic />
        <Notifications />
        <Sentry />
        <Glimr />
        <AppNexusConfig></AppNexusConfig>
        <GoogleTagmanagerConfigurator />
        <LoginAlert />
        <GlobalData />
        <RestoreScroll />
        {this.state.hasError ? <ErrorComponent error="500" noIndex /> : this.props.children}
        <Performance />
        <script defer src={`${staticFilesUrl}assets/scripts/gdpr-bundle.js`} />
      </TrackPlacementProvider>
    )
  }
}

Root.propTypes = {
  children: PropTypes.node,
}

export default Root
